<template>
    <input 
        :class="{
            'border-gray-300 focus:border-primary focus:ring focus:ring-primary-light focus:ring-opacity-50 rounded-md shadow-sm w-full': variant === 'default',
            'border-red-500 bg-red-100': hasError,
        }"
        :type="type"
        :value="modelValue" 
        :required="required"
        @input="$emit('update:modelValue', $event.target.value)" 
        ref="input"
    >
</template>

<script>
    export default {
        props: {
            modelValue: {
                type: [String, Number],
                default: '',
            },
            type: {
                type: String,
                default: 'text',
            },
            required: {
                type: Boolean,
                default: false,
            },
            hasError: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: 'default',
            },
        },

        emits: ['update:modelValue'],

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>